// AddRosterDialog.js
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from '@mui/material';

const AddRosterDialog = ({
                             isOpen,
                             onClose,
                             newRosterName,
                             setNewRosterName,
                             handleAddRoster
                         }) => {
    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogTitle>Add New Roster</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Roster Name"
                    fullWidth
                    value={newRosterName}
                    onChange={(e) => setNewRosterName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleAddRoster}>Add</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddRosterDialog;